import React from 'react';

import Button from './button';

const InputButton = props => {
  const { children, placeholder = '', value, onChange, onSubmit, className } = props;
  const prefix = <input value={value} className="input-button" placeholder={placeholder} onChange={onChange} />;
  return (
    <Button type="primary" className={`input-button-wrap ${className}`} prefix={prefix} onClick={onSubmit}>
      {children}
    </Button>
  );
};

export default InputButton;
